var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.607,
    height: 39.607,
    viewBox: "0 0 39.607 39.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c4067ea13a0109e58cd0c2fc71e6b022",
    transform: "translate(20.596) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5191",
    "data-name": "Path 5191",
    d: "M13.443,15.684a2.034,2.034,0,0,1-1.568-.672L.672,3.809a2.166,2.166,0,0,1,0-3.137,2.166,2.166,0,0,1,3.137,0l11.2,11.2a2.166,2.166,0,0,1,0,3.137,2.034,2.034,0,0,1-1.568.672Z",
    transform: "translate(11.203 0)",
    fill: "#f14234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5192",
    "data-name": "Path 5192",
    d: "M2.241,15.684a2.034,2.034,0,0,1-1.568-.672,2.166,2.166,0,0,1,0-3.137l11.2-11.2a2.166,2.166,0,0,1,3.137,0,2.166,2.166,0,0,1,0,3.137l-11.2,11.2a2.034,2.034,0,0,1-1.568.672Z",
    transform: "translate(0 0)",
    fill: "#f14234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5193",
    "data-name": "Path 5193",
    d: "M2.241,40.329A2.117,2.117,0,0,1,0,38.089V2.241A2.117,2.117,0,0,1,2.241,0,2.117,2.117,0,0,1,4.481,2.241V38.089A2.117,2.117,0,0,1,2.241,40.329Z",
    transform: "translate(11.203 0)",
    fill: "#f14234"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowR);
export default __webpack_public_path__ + "static/media/arrow-r.acb5d37647e59062a95023fbf7411e86.svg";
export { ForwardRef as ReactComponent };